module.exports = __webpack_public_path__ + "img/ic_head_hight_3.86ebd778.png";